module.exports = __webpack_public_path__ + "static/media/verbraucherinformationen-und-widerrufsbelehrung-april-2021.3cba4590.pdf";